import { render, staticRenderFns } from "./DescriptionModule.vue?vue&type=template&id=43ebc40a&"
import script from "./DescriptionModule.vue?vue&type=script&lang=js&"
export * from "./DescriptionModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports